export default "__VITE_ASSET__e1c6c840__"